export default {
  path: "*",
  name: "Error404",
  component: () => import("@/views/ErrorPages/Error404"),
  meta: {
    middleware_excemption: true
  }
};
